import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { SilentRequest } from '@azure/msal-browser';
import { environment } from '../../../../environments/environment';
import { Observable, switchMap, tap } from 'rxjs';


export const authInterceptor: HttpInterceptorFn = (req, next) => {
  let accessToken: string = '';
  const msalService = inject(MsalService);
  const accessTokenRequest: SilentRequest = {
    scopes: environment.apiConfig.scopes,
    account: msalService.instance.getAllAccounts()[0],
  };
  return msalService.acquireTokenSilent(accessTokenRequest).pipe(
    tap((response) => {
      accessToken = response.accessToken;
    }),
    switchMap((response) => {
      const newReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${response.accessToken}`,
          'Access-Control-Allow-Origin': '*',
        },
      });
      return next(newReq);
    })
  );
};